(function(){
  'use strict';
  const serviceVariants = {
    legacy: 56639019843924,
    tier10: 56896939917652,
    tier16: 56896939950420,
    tier21: 56896939983188,
    tier31: 56896940015956,
    tier50: 56896940048724,
    setup: 57211697332564,
    obsoleteSetup: 56535193157972
  };
  const tierServiceIds = [serviceVariants.legacy,serviceVariants.tier10,serviceVariants.tier16,serviceVariants.tier21,serviceVariants.tier31,serviceVariants.tier50];
  const serviceIds = Object.values(serviceVariants);
  let syncing = null;
  const isService = id => serviceIds.includes(Number(id));
  const decoratedQuantity = cart => (cart.items || []).reduce((total,item)=>{
    if(isService(item.variant_id)) return total;
    const decoration=item.properties&&(item.properties.Decoration||item.properties.Branding);
    return decoration&&decoration!=='No decoration'&&decoration!=='Plain'?total+Number(item.quantity||0):total;
  },0);
  const tierFor = quantity => {
    if(quantity>=50) return {id:serviceVariants.tier50,net:2.50,label:'50+'};
    if(quantity>=31) return {id:serviceVariants.tier31,net:2.99,label:'31–49'};
    if(quantity>=21) return {id:serviceVariants.tier21,net:3.49,label:'21–30'};
    if(quantity>=16) return {id:serviceVariants.tier16,net:3.99,label:'16–20'};
    return {id:serviceVariants.tier10,net:4.99,label:'10–15'};
  };
  async function getCart(){return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json())}
  async function sync(){
    if(syncing) return syncing;
    syncing=(async()=>{
      let cart=await getCart(),qty=decoratedQuantity(cart),services=cart.items.filter(i=>isService(i.variant_id));
      const updates={};
      if(qty===0){
        services.forEach(i=>updates[i.key]=0);
      }else{
        const tier=tierFor(qty);
        const correct=services.find(i=>Number(i.variant_id)===tier.id);
        const setup=services.find(i=>Number(i.variant_id)===serviceVariants.setup);
        services.forEach(i=>{const id=Number(i.variant_id);if(id===serviceVariants.obsoleteSetup)updates[i.key]=0;if(tierServiceIds.includes(id)&&(!correct||i.key!==correct.key))updates[i.key]=0});
        if(correct&&Number(correct.quantity)!==qty)updates[correct.key]=qty;
        if(setup&&Number(setup.quantity)!==1)updates[setup.key]=1;
        if(Object.keys(updates).length){
          await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
          cart=await getCart(); services=cart.items.filter(i=>isService(i.variant_id));
        }
        const missing=[];
        if(!services.some(i=>Number(i.variant_id)===tier.id)) missing.push({id:tier.id,quantity:qty,properties:{_lmu_decoration_service:'true',_lmu_branding_tier:tier.label}});
        if(!services.some(i=>Number(i.variant_id)===serviceVariants.setup)) missing.push({id:serviceVariants.setup,quantity:1,properties:{_lmu_decoration_service:'true',_lmu_logo_setup:'true'}});
        if(missing.length){
          await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:missing})});
          cart=await getCart();
        }
      }
      renderPolicy(cart);
      return cart;
    })().finally(()=>{syncing=null});
    return syncing;
  }
  function renderPolicy(cart){
    const qty=decoratedQuantity(cart),tier=qty?tierFor(qty):null;
    document.querySelectorAll('[data-lmu-branding-policy]').forEach(el=>{
      if(!qty){el.textContent='Plain garments have no minimum order. Branding requires at least 10 garments online.';el.dataset.state='plain';return}
      if(qty<10){el.textContent=`Add ${10-qty} more branded garment${10-qty===1?'':'s'} to reach the 10-garment online minimum.`;el.dataset.state='blocked';return}
      el.textContent=`${qty} branded garments · ${tier.label} tier · £${tier.net.toFixed(2)} + VAT per logo application.`;el.dataset.state='valid';
    });
  }
  function showMinimum(quantity){
    const remaining=10-quantity;
    let box=document.querySelector('[data-lmu-branding-minimum-error]');
    if(!box){box=document.createElement('div');box.setAttribute('data-lmu-branding-minimum-error','');box.setAttribute('role','alert');box.style.cssText='margin:12px 0;padding:14px 16px;border:2px solid #c2410c;border-radius:10px;background:#fff7ed;color:#7c2d12;font-weight:800';const target=document.querySelector('.lmu-cart-v1__checkout,#CartDrawer-Checkout,[name="checkout"]');target?.parentNode?.insertBefore(box,target)}
    box.textContent=`Online embroidery and print orders require at least 10 branded garments. Add ${remaining} more branded garment${remaining===1?'':'s'}, or remove branding and order the garments plain.`;
    box.scrollIntoView({block:'center',behavior:'smooth'});
  }
  async function checkout(event){
    const target=event.target&&event.target.closest&&event.target.closest('a[href="/checkout"],a[href$="/checkout"],[name="checkout"],#CartDrawer-Checkout');
    if(!target) return;
    event.preventDefault();event.stopImmediatePropagation();
    const cart=await sync(),qty=decoratedQuantity(cart);
    if(qty>0&&qty<10){showMinimum(qty);return}
    window.location.assign('/checkout');
  }
  document.addEventListener('click',checkout,true);
  document.addEventListener('submit',function(event){if(event.submitter&&(event.submitter.name==='checkout'||event.submitter.id==='CartDrawer-Checkout'))checkout(event)},true);
  window.addEventListener('lmu:item-added',()=>setTimeout(sync,0));
  document.addEventListener('DOMContentLoaded',()=>{if(document.querySelector('[data-lmu-cart-page],[data-cart-drawer]'))sync().catch(()=>{})});
  window.LMUBranding={serviceIds,isService,decoratedQuantity,tierFor,sync,getCart};
})();